module.exports = __webpack_public_path__ + "media/assets/smallLogo-85b13c515ca7c3107fa03bda431d5e5a.png";